// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wkpf","rootNoMargin":"styles_rootNoMargin__lOCpY"};